import React from "react";
import { Table, Avatar, Typography, Space } from "antd";
import TeamActions from "./TeamActions";
import UserRoleTag from "./../users-management/UserRoleTag";
import UserStatusTag from "./../users-management/UserStatusTag";

const { Title, Text } = Typography;

const TeamTable = ({
  currentUser,
  members,
  loading,
  onView,
  onEdit,
  onDelete,
  onToggleStatus
}) => {

  const columns = [
    {
      title: "MEMBER",
      key: "member",
      render: (_, m) => (
        <Space>
          <Avatar>{m.full_name?.charAt(0)}</Avatar>
          <Space direction="vertical" size={0}>
            <Title level={5}>{m.full_name}</Title>
            <Text type="secondary">{m.email}</Text>
          </Space>
        </Space>
      )
    },
    {
      title: "ROLE",
      render: (_, m) => <UserRoleTag role={m.role} />
    },
    {
      title: "STATUS",
      render: (_, m) => <UserStatusTag user={m} />
    },
    {
      title: "ACTIONS",
      render: (_, m) => (
        <TeamActions
          currentUser={currentUser}
          member={m}
          onView={() => onView(m)}
          onEdit={() => onEdit(m)}
          onDelete={() => onDelete(m)}
          onToggleStatus={() => onToggleStatus(m)}
        />
      )
    }
  ];

  return (
    <Table
      columns={columns}
      dataSource={members}
      loading={loading}
      pagination={{ pageSize: 10 }}
    />
  );
};

export default TeamTable;
